module.exports = __webpack_public_path__ + "prod/1.42.2/img/wudian-dian.fa10f63c.png";